module.exports = __webpack_public_path__ + "media/react/pages/essay_review/illustrated-avatars/1-615145c6bde19ece1e1e0e2dc902c9a9.png";